var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { k as CustomEvents, J as morph, q as activateInteractionAssets } from "./utilities-Da0sjanJ.js";
class ProductCountdownTimerV2 extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "handleVariantPickerUpdate", (event) => {
      if (event.detail.data.productId !== this.dataset.productId) return;
      const newCountdownTimer = event.detail.data.html.querySelector("product-countdown-timer-v2");
      if (newCountdownTimer) {
        morph(this, newCountdownTimer);
        activateInteractionAssets(this);
      }
    });
  }
  connectedCallback() {
    const section = this.closest(".shopify-section");
    if (!section) return;
    section.addEventListener(CustomEvents.variantPickerUpdate, this.handleVariantPickerUpdate);
  }
}
if (!customElements.get("product-countdown-timer-v2")) {
  customElements.define("product-countdown-timer-v2", ProductCountdownTimerV2);
}
